import { render } from "./StockItemBulkAddition.vue?vue&type=template&id=3e406408&ts=true"
import script from "./StockItemBulkAddition.vue?vue&type=script&lang=ts"
export * from "./StockItemBulkAddition.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__